import React from 'react';
import PropTypes from 'prop-types';
import { SelectFilter } from './Filters/SelectFilter.js';
import { getActiveRuleSetFromUrl } from '../utils/UrlUtil.js';
import { i18n } from '../i18n/translate.js';
var HeaderMenuAppSwitcher = function HeaderMenuAppSwitcher(_ref) {
  var _ref$currentRuleSets = _ref.currentRuleSets,
    currentRuleSets = _ref$currentRuleSets === void 0 ? [] : _ref$currentRuleSets,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    onRedirect = _ref.onRedirect;
  var t = i18n.t;
  var APP_OPTIONS = Object.freeze([{
    slug: 'train',
    group: 'Train',
    label: t('Train'),
    details: t('Assign and manage learning'),
    icon: 'building-shield'
  }, {
    slug: 'learn',
    group: 'Learn',
    label: t('Learn'),
    details: t('Complete training assigned to you'),
    icon: 'puzzle'
  }, {
    slug: 'impact',
    group: 'Impact',
    label: t('Impact'),
    details: t('View the impact of initiatives'),
    icon: 'bullseye-arrow'
  }, {
    slug: 'promote',
    group: 'Promote',
    label: t('Promote'),
    details: t('Manage marketing programs'),
    icon: 'flag-checkered'
  }, {
    slug: 'engage',
    group: 'Engage',
    label: t('Engage'),
    details: t('Manage webinars and in-person events'),
    icon: 'microchip'
  }]);
  var activeRuleSet = getActiveRuleSetFromUrl(currentRuleSets);
  var availableApps = APP_OPTIONS.filter(function (appOption) {
    return menuItems.some(function (menuItem) {
      return menuItem.slug === appOption.slug;
    });
  });
  var defaultApp = availableApps.find(function (appOption) {
    return appOption.group === activeRuleSet.interstitial_group;
  });
  var onChange = function onChange(selectedApp) {
    var menuItem = menuItems.find(function (menuItem) {
      return menuItem.slug === selectedApp.slug;
    });
    if (menuItem) {
      onRedirect(menuItem.target_url);
    }
  };

  // no appswitcher if there is not more that one train role to choose from
  if (availableApps.length < 2) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "header-menu-app-switcher"
    }, /*#__PURE__*/React.createElement(SelectFilter, {
      defaultValue: defaultApp,
      explainerKey: "details",
      iconFamily: "fi-icon",
      iconKey: "icon",
      isClearable: false,
      name: "available_apps",
      onChange: onChange,
      options: availableApps,
      showSelected: true,
      valueKey: "group"
    }));
  }
};
HeaderMenuAppSwitcher.propTypes = {
  currentRuleSets: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    interstitial_group: PropTypes.string
  })),
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    target_url: PropTypes.string
  })),
  onRedirect: PropTypes.func
};
export { HeaderMenuAppSwitcher };